// Simplified Chinese UI catalog — generated from the English strings used in the JSX (English text is the key).
// Regenerate the key list with scripts/i18n-keys.mjs; keep entries in English order.
export const zhCN: Record<string, string> = {
  "Active only": "仅显示进行中",
  "Attach files": "附加文件",
  "Attach files to the comment; you can also paste or drop them into it": "将文件附加到评论；也可以直接粘贴或拖放到评论中",
  "Attach files to this task; you can also drop them here": "将文件附加到此任务；也可以拖放到这里",
  "Attachments": "附件",
  "Delete {name}?": "删除 {name}？",
  "Download": "下载",
  "No files yet. Drop files here or use Attach files.": "还没有文件。将文件拖放到这里，或使用“附加文件”。",
  "No files.": "没有文件。",
  "Remove this file": "移除此文件",
  "Show only tasks in progress, hiding the backlog and done. Remembered, and shared by the task views.": "仅显示进行中的任务，隐藏待办列表和已完成任务。该选择会被记住，并在各任务视图间共享。",
  "Hide tasks that are done. Remembered, and shared by the task views.": "隐藏已完成的任务。该选择会被记住，并在各任务视图间共享。",
  "Show backlog": "显示待办列表",
  "Upload failed": "上传失败",
  "Uploading 1 file…": "正在上传 1 个文件…",
  "Uploading {n} files…": "正在上传 {n} 个文件…",
  "With \"Active only\" on, also show tasks still in the backlog. Remembered.": "开启“仅显示进行中”时，同时显示仍在待办列表中的任务。该选择会被记住。",
  "Markdown · type @ to mention someone · Ctrl-Enter posts": "Markdown · 输入 @ 提及某人 · Ctrl-Enter 发布",
  "Nothing to preview yet.": "暂无可预览的内容。",
  "Show the comment formatted, as it will appear": "按发布后的样子显示带格式的评论",
  "Write": "编辑",
  "in a comment": "在评论中",
  "nav.home": "首页",
  "nav.time": "时间",
  "nav.timesheets": "工时表",
  "nav.leave": "假期",
  "nav.reports": "报表",
  "nav.projects": "项目",
  "nav.people": "人员",
  "nav.payroll": "工资",
  "nav.admin": "管理",
  "nav.signout": "退出登录",
  "nav.portfolios": "项目组合",
  "1 year": "1 年",
  "30 days": "30 天",
  "90 days": "90 天",
  "A token lets Claude Code (or a script) act as you through the API: projects, portfolios, tasks, schedules, links, milestones and your time. It never reaches rates, budgets, payroll, approvals, admin or account settings, whatever your role.": "令牌允许 Claude Code（或脚本）通过 API 以你的身份操作：项目、项目组合、任务、排程、链接、里程碑和你的工时。无论你的角色如何，它都无法访问费率、预算、薪资、审批、管理或账户设置。",
  "Create token": "创建令牌",
  "Created": "创建时间",
  "Dismiss": "关闭",
  "Read tokens can only look; write tokens can also create and change tasks, links, milestones and time entries. Everything a token does is audited as you, marked with the token's name.": "只读令牌只能查看；读写令牌还可以创建和修改任务、链接、里程碑和工时记录。令牌的所有操作都以你的身份审计，并标注令牌名称。",
  "Read: look only. Write: create and change tasks, links, milestones and time": "只读：仅查看。读写：创建和修改任务、链接、里程碑和工时",
  "Revoke": "撤销",
  "Revoked:": "已撤销：",
  "Scope": "范围",
  "The token is shown once, when you create it. Revoke it here if it leaks.": "令牌仅在创建时显示一次。如有泄露，请在此撤销。",
  "Then start Claude Code and ask it, for example, \"what is overdue across my portfolio?\" or \"plan the importer epic in DEN with four tasks and link them\".": "然后启动 Claude Code，例如问它“我的项目组合中有哪些逾期？”或“在 DEN 中规划导入器史诗，包含四个任务并建立链接”。",
  "To use it from Claude Code, put it in your shell and add the server once:": "要在 Claude Code 中使用，请将其放入 shell 并添加一次服务器：",
  "Token": "令牌",
  "Token name, e.g. Claude Code on my laptop": "令牌名称，例如：我笔记本上的 Claude Code",
  "When the token stops working on its own": "令牌自动失效的时间",
  "created. Copy it now — it will not be shown again.": "已创建。请立即复制——不会再次显示。",
  "for Claude Code and scripts": "用于 Claude Code 和脚本",
  "login.title": "登录",
  "never expires": "永不过期",
  "read and write": "读写",
  "read only": "只读",
  "via API token": "通过 API 令牌",
  "login.email": "邮箱",
  "login.password": "密码",
  "login.button": "登录",
  "login.google": "使用 Google 继续",
  "login.passkey": "使用通行密钥登录",
  "login.or": "或使用密码",
  "common.save": "保存",
  "common.cancel": "取消",
  "common.delete": "删除",
  "common.edit": "编辑",
  "common.add": "添加",
  "common.loading": "加载中…",
  "time.start": "启动计时器",
  "time.stop": "停止并保存",
  "time.thisWeek": "本周",
  "offline.queued": "{n} 条时间记录已排队 — 恢复在线后发送",
  "offline.queuedPlural": "{n} 条时间记录已排队 — 恢复在线后发送",
  "+ Add": "+ 添加",
  "+ Task": "+ 任务",
  "+ sub": "+ 子",
  "1 person notified": "已通知 1 人",
  "1 private project hidden": "已隐藏 1 个私有项目",
  "1 private project is hidden from these totals.": "这些合计中隐藏了 1 个私有项目。",
  "1 project": "1 个项目",
  "1. Scan the code with your authenticator app, or enter this key manually:": "1. 用身份验证器应用扫描二维码，或手动输入此密钥：",
  "13 weeks": "13 周",
  "2. Enter the 6-digit code the app shows to confirm.": "2. 输入应用显示的 6 位验证码以确认。",
  "26 weeks": "26 周",
  "4 weeks": "4 周",
  "8 weeks": "8 周",
  "A flag is a named on/off switch you control here without a deploy. Every signed-in browser receives the current flags, and features can check them to show or hide something.": "功能开关是一个有名字的开/关按钮，无需部署即可在此控制。每个已登录的浏览器都会收到当前开关，功能可据此显示或隐藏内容。",
  "A person is": "当此人",
  "A portfolio groups related projects under one initiative (a client, a programme, a department) with a shared board, list and Gantt.": "项目组合将相关项目归入同一计划（客户、项目群、部门），并提供共享的看板、列表和甘特图。",
  "A portfolio groups related projects under one initiative (a client, a programme, a department).": "组合将相关项目归入同一计划（客户、项目群、部门）。",
  "A private project appears only in your own project list — no one else can see it, whatever their role": "私有项目仅出现在您自己的项目列表中 — 无论角色如何，其他人都看不到",
  "A simple sub-task with its own key; it appears here, not on the board": "一个带独立编号的简单子任务；它显示在这里，而不是看板上",
  "A token acts as this person through the API: projects, portfolios, tasks, schedules and their time, never rates, payroll or admin. Everything it does is audited as them, marked with the token's name, and your name is recorded as the one who issued it.": "令牌通过 API 以此人的身份操作：项目、项目组合、任务、排程和他们的工时，绝不涉及费率、工资或管理。它所做的一切都以此人身份记入审计日志并标注令牌名称，同时记录你作为签发者。",
  "API tokens": "API 令牌",
  "Account": "账户",
  "Accounts are invite-only. If you have an invite link, open it to set up your account.": "账户仅限邀请。如果您有邀请链接，请打开它来设置账户。",
  "Action": "操作",
  "Actions": "操作",
  "Add": "添加",
  "Add a comment": "添加评论",
  "Add a milestone on this day": "在此日添加里程碑",
  "Add a person": "添加人员",
  "Add a person…": "添加成员…",
  "Add a status column (columns are the project's statuses)": "添加状态列（列即项目的状态）",
  "Add a subtask under this task": "在此任务下添加子任务",
  "Add a task due on this day": "添加于此日到期的任务",
  "Add a task in this column": "在此列添加任务",
  "Add a top-level task": "添加顶级任务",
  "Add checklist item": "添加清单项",
  "Add column": "添加列",
  "Add entry": "添加记录",
  "Add holiday": "添加假期",
  "Add project…": "添加项目…",
  "Add rate": "添加费率",
  "Add subtask": "添加子任务",
  "Add task": "添加任务",
  "Add the column at the end; drag its header to reorder": "在末尾添加列；拖动表头可重新排序",
  "Add the item": "添加该项",
  "Added": "已添加",
  "Address / CIDR": "地址 / CIDR",
  "Addresses on file (restriction currently off):": "已登记的地址（当前未启用限制）：",
  "Adds a second step to password sign-in: a 6-digit code from an app such as Google Authenticator, 1Password or Authy.": "为密码登录增加第二步：来自 Google Authenticator、1Password 或 Authy 等应用的 6 位验证码。",
  "Admin console": "管理控制台",
  "After": "之后",
  "Alert at %": "在 % 时提醒",
  "All portfolios you can see; create one there": "您可见的所有项目组合；可在那里创建",
  "All projects": "所有项目",
  "All states": "所有状态",
  "Amount": "金额",
  "An account for an integration, left out of payroll, timesheets and scheduled reports": "供集成使用的账户，不计入工资、工时表和计划报表",
  "An invite lets them pick their own password. Creating an account here sends no email at all: it exists straight away, and you decide whether it has a password.": "邀请让对方自己设置密码。在这里创建账户不会发送任何邮件：账户立即存在，是否设置密码由你决定。",
  "Analytics": "分析",
  "Any action": "任意操作",
  "Any milestone": "任意里程碑",
  "Any priority": "任意优先级",
  "Any project": "任意项目",
  "Any status": "任意状态",
  "Anyone": "任何人",
  "Approvals": "审批",
  "Approve although it was not submitted — you'll be warned if the week is empty or thin, and the person is notified": "未提交也批准 — 若该周为空或过少会提醒您，并通知本人",
  "Approve without submission?": "未提交即批准？",
  "Approve — locks the week; any later work must be a correction entry": "批准 — 锁定该周；之后的工作须以更正记录添加",
  "Approve — reduces their available capacity for those days": "批准 — 减少其在这些天的可用工时",
  "Approved": "已批准",
  "Archive": "归档",
  "Archive this portfolio? Its projects are unchanged; the portfolio drops out of the default lists.": "归档此项目组合？其项目不变；该组合将从默认列表中移除。",
  "Assign to…": "分配给…",
  "Assignee": "负责人",
  "At a glance": "一览",
  "At least 12 characters. A password found in a public breach is refused.": "至少 12 个字符。出现在公开泄露数据中的密码会被拒绝。",
  "At least 12 characters. A short sentence works well.": "至少 12 个字符。一句简短的话很合适。",
  "Auto-schedule": "自动排程",
  "Avatar URL": "头像 URL",
  "Awaiting approval": "等待审批",
  "Awaiting your approval": "等待您审批",
  "Back": "返回",
  "Back to portfolios": "返回项目组合",
  "Back to projects": "返回项目列表",
  "Baseline": "基线",
  "Before": "之前",
  "Bill rates": "计费费率",
  "Billable + non": "计费 + 非计费",
  "Billable only": "仅计费",
  "Billable value": "计费金额",
  "Board": "看板",
  "Breadcrumb": "面包屑",
  "Budget": "预算",
  "Bulk-load people, projects, and an opening task backlog from CSV files.": "从 CSV 文件批量导入人员、项目和初始任务待办。",
  "Burndown / burnup": "燃尽 / 燃起",
  "Calendar": "日历",
  "Calendar settings": "日历设置",
  "Cancel": "取消",
  "Cancel this pending invite": "取消此待处理邀请",
  "Cancel this request (or approved leave that hasn't started)": "取消此申请（或尚未开始的已批准假期）",
  "Capacity": "可用工时",
  "Category": "类别",
  "Change any field on this person's record, including their email": "修改此人记录中的任何字段，包括邮箱",
  "Change password": "修改密码",
  "Change the email for {name} to {email}? That address is where password resets go, and they are told about the change.": "将 {name} 的邮箱改为 {email}？密码重置会发送到该地址，并会通知本人此次变更。",
  "Changes save as you edit; this confirms and closes the editor": "编辑时自动保存；此操作确认并关闭编辑器",
  "Checking invite…": "正在检查邀请…",
  "Checking…": "正在检查…",
  "Choose the timezone carefully — it cannot be changed afterwards.": "请谨慎选择时区 — 之后无法更改。",
  "Clear": "清除",
  "Click": "点击",
  "Click the": "点击",
  "Close": "关闭",
  "Code": "代码",
  "Collapse": "折叠",
  "Collapse this card": "折叠此卡片",
  "Collapse this section (remembered for you)": "折叠此区块（为您记住）",
  "Colour": "颜色",
  "Owner": "负责人",
  "Colour the task bars by owner (assignee). Remembered.": "按负责人（被分配者）为任务条着色。会被记住。",
  "Colour for this calendar's events": "此日历事件的颜色",
  "Column (status) name shown on the board": "看板上显示的列（状态）名称",
  "Column name": "列名",
  "Command": "命令",
  "Command palette": "命令面板",
  "Comment": "评论",
  "Comment deleted": "评论已删除",
  "Comment deleted by {name}": "评论已由 {name} 删除",
  "Comments": "评论",
  "Commit": "提交",
  "Company holidays": "公司假期",
  "Completed": "已完成",
  "Confirm new password": "确认新密码",
  "Confirm password": "确认密码",
  "Connect Google Calendar": "连接 Google 日历",
  "Connecting failed. Try again.": "连接失败。请重试。",
  "Continue with Google": "使用 Google 继续",
  "Copied": "已复制",
  "Copy all": "全部复制",
  "Copy link": "复制链接",
  "Copy password": "复制密码",
  "Copy the claude mcp add command": "复制 claude mcp add 命令",
  "Copy the export line": "复制 export 行",
  "Copy the password so you can pass it on": "复制密码以便转交",
  "Copy the token": "复制令牌",
  "Correct…": "更正…",
  "Cost rate": "成本费率",
  "Cost rates": "成本费率",
  "Could not create portfolio": "无法创建项目组合",
  "Could not load the overview.": "无法加载概览。",
  "Create a one-time invite link (7 days) and email it if mail is configured": "创建一次性邀请链接（7 天），若已配置邮件则同时发送邮件",
  "Create a project — you'll choose its permanent timezone-of-truth": "创建项目 — 您将选择其永久的基准时区",
  "Create a task scheduled today for one week; drag its bar to adjust": "创建一个从今天起为期一周的任务；拖动其条形以调整",
  "Create a top-level task in this project; open it afterwards to set dates, assignee, estimate": "在此项目创建顶级任务；之后打开以设置日期、负责人、估算",
  "Create account": "创建账户",
  "Create feed link": "创建订阅链接",
  "Create invite": "创建邀请",
  "Create one below, then file projects under it from a project's": "在下方创建一个，然后从项目的",
  "Create one from the Portfolios page, then file projects under it from a project's": "在项目组合页面创建一个，然后在各项目的以下位置将项目归入其中：",
  "Create project": "创建项目",
  "Create the account now — nobody is emailed": "立即创建账户 — 不会发送任何邮件",
  "Create the task": "创建任务",
  "Create the task in this column": "在此列创建任务",
  "Create your personal feed link": "创建您的个人订阅链接",
  "Cumulative flow": "累积流图",
  "Cumulative flow, cycle time, burndown, velocity, forecast": "累积流图、周期时间、燃尽、速率、预测",
  "Currency": "货币",
  "Current password": "当前密码",
  "Cycle (d)": "周期（天）",
  "Dashboard, projects, members, settings": "仪表盘、项目、成员、设置",
  "Dashboard, tasks, members, milestones, settings": "仪表盘、任务、成员、里程碑、设置",
  "Date": "日期",
  "Dates": "日期",
  "Dates in": "日期基于",
  "Day": "日",
  "Deactivate your account (history is kept); you will be asked to confirm": "停用您的账户（历史保留）；将要求您确认",
  "Decides whether this account can sign in the moment you create it": "决定此账户在创建后能否立即登录",
  "Decline with a reason; the person is notified": "附理由拒绝；本人会收到通知",
  "Delete": "删除",
  "Delete column": "删除列",
  "Delete milestone": "删除里程碑",
  "Delete task": "删除任务",
  "Delete this column (only when empty)": "删除此列（仅当为空时）",
  "Delete this comment? Its replies stay.": "删除这条评论？它的回复会保留。",
  "Delete this milestone": "删除此里程碑",
  "Delete this task": "删除此任务",
  "Delete this task (and its subtasks); logged time is kept": "删除此任务（及其子任务）；已记录的时间保留",
  "Resize the task list": "调整任务列表大小",
  "Drag to resize the task list; double-click to reset": "拖动以调整任务列表宽度；双击可重置",
  "Delete this task and its subtasks; logged time is kept": "删除此任务及其子任务；已记录的时间保留",
  "Description": "描述",
  "Directory": "通讯录",
  "Discard": "放弃",
  "Discuss this milestone": "讨论此里程碑",
  "Discussion": "讨论",
  "Display only — never changes which week an entry belongs to.": "仅用于显示 — 绝不改变记录所属的周。",
  "Does not match.": "不匹配。",
  "Done": "完成",
  "Download CSV": "下载 CSV",
  "Download a JSON file with everything stored about you": "下载包含您所有存储数据的 JSON 文件",
  "Download as a PDF table": "下载为 PDF 表格",
  "Download as an Excel workbook": "下载为 Excel 工作簿",
  "Download everything stored about you — profile, memberships, time entries, tasks assigned, leave, approvals, notifications — as JSON.": "以 JSON 下载关于您的所有存储数据 — 资料、成员关系、时间记录、分配的任务、假期、审批、通知。",
  "Download my data": "下载我的数据",
  "Download partial CSV": "下载部分 CSV",
  "Download these rows as CSV": "将这些行下载为 CSV",
  "Drag cards, or focus a card and press": "拖动卡片，或聚焦卡片后按",
  "Drag to change priority; Space + arrows works from the keyboard": "拖动以更改优先级；键盘可用空格 + 方向键",
  "Drag to move between columns or reorder; Space + arrows works from the keyboard": "拖动以在列间移动或重新排序；键盘可用空格 + 方向键",
  "Drop idle time — save up to the idle moment, then restart": "丢弃空闲时间 — 保存到空闲时刻，然后重新开始",
  "Due": "到期",
  "Each status maps to a global category (to do / in progress / done / archived) so reporting works across projects. Keep at least one per category. Archived work is left out of every count and hidden unless asked for.": "每个状态映射到一个全局类别（待办 / 进行中 / 完成 / 已归档），以便跨项目报表正常工作。每类至少保留一个。已归档的工作不计入任何统计，除非要求否则隐藏。",
  "Archived": "已归档",
  "Also show tasks in an archived status. Remembered, and shared by the task views and the board.": "同时显示处于已归档状态的任务。该选择会被记住，并在各任务视图和看板间共享。",
  "Waterfall": "瀑布排列",
  "Lay linked tasks out left to right: any task that overlaps what its links allow moves later (keeping its length), then rows are ordered by start, linked ones in link order. Done and archived tasks stay put. Saved; press again after changes.": "将有链接的任务从左到右排列：任何与其链接约束重叠的任务会在保持工期的前提下后移，然后按开始日期排列行，有链接的按链接顺序。已完成和已归档的任务不动。会被保存；更改后可再次点击。",
  "Waterfall:": "瀑布排列：",
  "rescheduled": "个已重排日程",
  "reordered": "个已重新排序",
  "Already a waterfall: nothing to change": "已是瀑布排列：无需更改",
  "Could not reschedule the tasks": "无法重新排程任务",
  "Auto-schedule:": "自动排程：",
  "Already scheduled: nothing to change": "已排程：无需更改",
  "Auto-schedule replans every open task: in-progress work first, then linked tasks as soon as their links allow and others from today, so nobody gets two tasks at once. Continue?": "自动排程会重新规划所有未完成的任务：先安排进行中的工作，再让有链接的任务在链接允许时尽早开始，其他从今天开始，因此任何人都不会同时有两个任务。继续吗？",
  "Plan the open tasks as soon as possible: linked ones right after their links allow, unlinked past or undated ones from today (undated take their estimate at 8h a day, or 5 days), future unlinked ones keep their start. Each person's tasks are queued, in-progress first and then by priority, so they never overlap, counting their other projects. Done and archived tasks stay put. Saved.": "尽早规划未完成的任务：有链接的在链接允许后立即开始，无链接的过去或无日期任务从今天开始（无日期任务按每天 8 小时折算估算，或 5 天），无链接的未来任务保留开始日期。每个人的任务排队，进行中的优先，然后按优先级，以避免重叠，并计入其其他项目。已完成和已归档的任务保持不动。会被保存。",
  "working days": "个工作日",
  "estimated": "小时（估算）",
  "Edit": "编辑",
  "Edit person": "编辑人员",
  "Edit your comment; the previous text is kept as history": "编辑你的评论；原文会作为历史记录保留",
  "Elapsed": "已用时",
  "Email": "邮箱",
  "End this session and return to the sign-in page (other devices stay signed in)": "结束此会话并返回登录页（其他设备保持登录）",
  "Ends": "结束",
  "Enter the 6-digit code from your authenticator app, or one of your recovery codes.": "输入身份验证器应用的 6 位验证码，或您的某个恢复码。",
  "Epic": "史诗",
  "Est.": "估算",
  "Estimate (h)": "估算（小时）",
  "Every project-week approved": "所有项目周均已批准",
  "Everyone": "所有人",
  "Everyone (admin)": "所有人（管理员）",
  "Everyone in the range is approved — download the payroll CSV": "范围内所有人均已批准 — 下载工资 CSV",
  "Everything on this person's record. Changes are audit-logged against your name.": "此人记录的全部内容。更改会以你的名义记入审计日志。",
  "Examples:": "示例：",
  "Excludes people who still have unapproved weeks; they are named in the file header": "不包含仍有未批准周的人；他们会在文件头中列出",
  "Expand": "展开",
  "Expand this card to see details": "展开此卡片查看详情",
  "Expand this section (remembered for you)": "展开此区块（为您记住）",
  "Expires": "过期",
  "External calendars (in)": "外部日历（导入）",
  "Feature flags": "功能开关",
  "Field": "字段",
  "Filter the list by project code or name": "按项目代码或名称筛选列表",
  "Final step: deactivate the account now": "最后一步：立即停用账户",
  "For an integration such as Claude Code rather than a colleague: it stays out of payroll, timesheets and scheduled reports.": "用于 Claude Code 这类集成而非同事：不计入工资、工时表和计划报表。",
  "Format": "格式",
  "From": "从",
  "From your calendar today": "来自您今天的日历",
  "Gantt": "甘特图",
  "Global category this column maps to, so cross-project reports keep working": "此列对应的全局类别，以保证跨项目报表正常",
  "Google did not grant offline access — remove ADKOM PM under your Google account’s third-party access, then connect again.": "Google 未授予离线访问权限 — 请在您的 Google 账户第三方访问中移除 ADKOM PM，然后重新连接。",
  "Grant read-only access; today's meetings become one-click time entry suggestions": "授予只读访问；今天的会议将成为一键时间记录建议",
  "Group by": "分组依据",
  "Group the board into rows by assignee, epic or priority": "按负责人、史诗或优先级将看板分行",
  "Has unapproved weeks": "有未批准的周",
  "Hidden projects are a personal view preference; nothing about the project changes": "隐藏项目只是个人视图偏好；项目本身不会改变",
  "Hide subtasks": "隐藏子任务",
  "Hide this milestone's discussion": "隐藏此里程碑的讨论",
  "Hide this project from your lists (just for you; the project is unchanged)": "从您的列表中隐藏此项目（仅对您；项目不变）",
  "Hide this project's tasks": "隐藏此项目的任务",
  "Hours": "小时",
  "Hours (30d)": "小时（30 天）",
  "Hours for other members are visible to project administrators and managers.": "其他成员的工时对项目管理员和经理可见。",
  "Hours per week": "每周小时数",
  "Hours/wk": "小时/周",
  "How much of their time the schedule may plan for.": "排程可以为其安排多少时间。",
  "IP allowlist set by an administrator": "由管理员设置的 IP 允许列表",
  "Identifies this project's tasks on portfolio boards and Gantts": "用于在项目组合的看板和甘特图中标识此项目的任务",
  "Import": "导入",
  "Import in order: people → projects → tasks.": "按顺序导入：人员 → 项目 → 任务。",
  "In progress": "进行中",
  "Include accounts used by integrations, which are hidden by default": "显示默认隐藏的集成账户",
  "Invite": "邀请",
  "Invite colleagues and manage roles.": "邀请同事并管理角色。",
  "Invite for": "邀请对象",
  "Issue a token for this person and show it once": "为此人签发令牌，并只显示一次",
  "Issue or revoke tokens that act as this person through the API": "签发或撤销通过 API 以此人身份操作的令牌",
  "Issues assigned to this GitHub user become tasks assigned to them.": "分配给此 GitHub 用户的 issue 会成为分配给此人的任务。",
  "Job title": "职位",
  "Jump to the current week": "跳到本周",
  "Jump to the top of the page": "跳到页面顶部",
  "Jump to top": "回到顶部",
  "Kanban board across every project in the portfolio": "跨项目组合中所有项目的看板",
  "Kanban board: drag cards between status columns": "看板：在状态列之间拖动卡片",
  "Keep": "保留",
  "Keep the account": "保留账户",
  "Keep — count the idle time as work": "保留 — 将空闲时间计为工作",
  "Keeps this account out of payroll, timesheets and scheduled reports.": "使此账户不计入工资、工时表和计划报表。",
  "Key": "编号",
  "Kind": "类型",
  "Label": "标签",
  "Language": "语言",
  "Last": "最近",
  "Last active": "最近活动",
  "Last run": "上次运行",
  "Last sign-in": "上次登录",
  "Last used": "上次使用",
  "Lead (d)": "前置（天）",
  "Leave": "假期",
  "Leave it empty to follow the organisation's working week.": "留空则沿用组织的工作周。",
  "Line": "行",
  "List": "列表",
  "Loading…": "加载中…",
  "Log time →": "记录时间 →",
  "Logged": "已记录",
  "Managed by": "负责人：",
  "Manager": "经理",
  "Median cycle time": "周期时间中位数",
  "Median lead time": "前置时间中位数",
  "Member": "成员",
  "Members": "成员",
  "Mention someone": "提及某人",
  "Milestone": "里程碑",
  "Milestones": "里程碑",
  "Milestone…": "里程碑…",
  "Mine open": "我的未完成",
  "Month": "月",
  "Month view of due dates, milestones and external calendars": "按到期日、里程碑和外部日历的月视图",
  "More actions for this row": "此行的更多操作",
  "Move this status up one place": "将此状态上移一位",
  "Move up": "上移",
  "Moving a project out of a portfolio is refused while it has cross-project links": "项目存在跨项目链接时，无法将其移出项目组合",
  "My private projects": "我的私有项目",
  "My reports": "我的报表",
  "My requests": "我的申请",
  "My tasks": "我的任务",
  "Name": "名称",
  "New milestone": "新建里程碑",
  "New password": "新密码",
  "New portfolio": "新建项目组合",
  "New portfolio name": "新组合名称",
  "New project": "新建项目",
  "New status": "新建状态",
  "New subtask": "新建子任务",
  "New task": "新建任务",
  "New task in": "新建任务于",
  "New task title": "新任务标题",
  "New timer": "新计时器",
  "Next milestone": "下一个里程碑",
  "Next month": "下个月",
  "Next run": "下次运行",
  "Next week": "下周",
  "No comments yet.": "还没有评论。",
  "No completed work in the window yet.": "此时间窗内尚无已完成的工作。",
  "No cost rate yet.": "尚无成本费率。",
  "No data.": "无数据。",
  "No earlier versions.": "没有更早的版本。",
  "No feed link yet.": "尚无订阅链接。",
  "No hours budget set.": "未设置工时预算。",
  "No members yet.": "尚无成员。",
  "No milestones yet.": "尚无里程碑。",
  "No money budget set.": "未设置金额预算。",
  "No open milestones with a due date.": "没有带到期日的未完成里程碑。",
  "No portfolios yet.": "尚无项目组合。",
  "No projects filed here yet.": "尚未归入任何项目。",
  "No projects in this portfolio yet.": "此项目组合中尚无项目。",
  "No projects match.": "没有匹配的项目。",
  "No projects yet.": "尚无项目。",
  "No projects.": "没有项目。",
  "No tasks yet.": "尚无任务。",
  "No tasks.": "没有任务。",
  "No time in this range.": "此范围内没有时间记录。",
  "No time in this window.": "此时间窗内没有时间记录。",
  "No time matches.": "没有匹配的时间记录。",
  "No tokens yet.": "还没有令牌。",
  "Non-billable only": "仅非计费",
  "None": "无",
  "None yet.": "尚无。",
  "Not available — approvals are for project administrators.": "不可用 — 审批仅限项目管理员。",
  "Not configured on this server.": "此服务器未配置。",
  "Not enough history yet for a trend — the weekly chart appears after two weeks of entries.": "历史尚不足以显示趋势 — 周图表将在两周记录后出现。",
  "Not enough history yet for trends and forecasts — they firm up after a couple of weeks of tasks moving. What is here is exact, just short.": "历史尚不足以显示趋势和预测 — 任务流动几周后会趋于稳定。这里的数据是精确的，只是较短。",
  "Not enough history yet — the chart appears once two project weeks have entries.": "历史尚不足 — 两个项目周有记录后图表才会出现。",
  "Not submitted": "未提交",
  "Note": "备注",
  "Note (optional)": "备注（可选）",
  "Note saved onto the entry": "备注保存到记录",
  "Note saved onto the time entry when you stop": "停止时备注保存到时间记录",
  "Notes": "备注",
  "Nothing assigned to you.": "没有分配给您的内容。",
  "Nothing completed yet.": "尚无已完成项。",
  "Nothing here.": "这里没有内容。",
  "Nothing logged yet.": "尚无记录。",
  "Nothing recorded yet.": "尚无记录。",
  "Nothing yet.": "尚无。",
  "Notifications": "通知",
  "Now click the task that must wait for": "现在点击需要等待的任务：",
  "On enter": "进入时",
  "One submission per project per week, in each project's own timezone.": "每个项目每周一次提交，以各项目自身时区为准。",
  "Only ephemeral records are ever purged. Business history — time entries, approvals, tasks, the audit log, status transitions — is never touched.": "仅清除临时记录。业务历史 — 时间记录、审批、任务、审计日志、状态变更 — 绝不触碰。",
  "Only you can see these. Drag to prioritize.": "仅您可见。拖动以排定优先级。",
  "Open People": "打开人员",
  "Open People: directory, roles, invites": "打开人员：通讯录、角色、邀请",
  "Open Projects": "打开项目",
  "Open Reports to slice logged time": "打开报表以分析已记录时间",
  "Open portfolio →": "打开项目组合 →",
  "Open tasks": "未完成任务",
  "Open the Gantt chart": "打开甘特图",
  "Open the Kanban board": "打开看板",
  "Open the Time page: edit timers, notes, tasks": "打开时间页面：编辑计时器、备注、任务",
  "Open the portfolio": "打开项目组合",
  "Open the portfolio: shared board, list and Gantt across its projects": "打开项目组合：跨其项目的共享看板、列表和甘特图",
  "Open the project": "打开项目",
  "Open the task": "打开任务",
  "Outstanding": "待处理",
  "Overdue": "逾期",
  "Overview": "概览",
  "Parent": "父级",
  "Password": "密码",
  "Paste CSV here…": "在此粘贴 CSV…",
  "Pause": "暂停",
  "Pause this timer; time is kept": "暂停此计时器；时间保留",
  "Pause; time is kept": "暂停；时间保留",
  "Payroll export": "工资导出",
  "Pending": "待处理",
  "People": "人员",
  "Per-project feeds:": "按项目订阅：",
  "Permanent. Create a new project to use a different zone.": "永久性。要使用其他时区请新建项目。",
  "Person": "人员",
  "Person…": "人员…",
  "Pick the range by": "按以下方式选择范围",
  "Portfolio": "组合",
  "Portfolio manager": "项目组合经理",
  "Portfolio not found, or you do not have access.": "未找到项目组合，或您没有访问权限。",
  "Portfolio role": "项目组合角色",
  "Portfolio roles grant access to the merged views; task edits still follow each project's own membership.": "项目组合角色授予合并视图的访问权限；任务编辑仍遵循各项目自身的成员关系。",
  "Portfolios": "组合",
  "Portfolios don't affect approvals — they add a shared board, list and Gantt, and cross-project links.": "项目组合不影响审批 — 它们提供共享的看板、列表和甘特图，以及跨项目链接。",
  "Portfolios don't affect permissions or approvals — they are purely for organising and reporting.": "组合不影响权限或审批 — 仅用于组织和报表。",
  "Portfolios →": "项目组合 →",
  "Post the comment": "发布评论",
  "Post the comment (Ctrl-Enter)": "发布评论（Ctrl-Enter）",
  "Prev": "上一",
  "Preview": "预览",
  "Previous month": "上个月",
  "Previous week": "上周",
  "Priority": "优先级",
  "Priority…": "优先级…",
  "Private projects filed here that only their owners can see": "归入此处的私有项目，仅其所有者可见",
  "Private — only you can see this project": "私有 — 仅您可以看到此项目",
  "Private — only you will see this project": "私有 — 仅您会看到此项目",
  "Progress": "进度",
  "Project": "项目",
  "Project colour": "项目颜色",
  "Project not found, or you do not have access.": "未找到项目，或您没有访问权限。",
  "Project not found.": "未找到项目。",
  "Project role": "项目角色",
  "Project the new task belongs to": "新任务所属的项目",
  "Projected finish": "预计完成",
  "Projects": "项目",
  "Projects not yet in a portfolio that you may update": "您可更新且尚未加入项目组合的项目",
  "Projects you are a member of.": "您所属的项目。",
  "Projects you can see. Managers and admins see all.": "您可见的项目。经理和管理员可见全部。",
  "Purge immediately using the currently saved policy (not unsaved edits) and record the counts above": "立即按当前已保存的策略（而非未保存的编辑）清除，并在上方记录数量",
  "Push successors when a task moves": "任务移动时推移后继任务",
  "Range": "范围",
  "Rates are visible to managers and administrators.": "费率对经理和管理员可见。",
  "Read this first.": "请先阅读。",
  "Read-only: today’s meetings appear as one-click suggestions on the Time page. Your entries flow back to any calendar through the": "只读：今天的会议会以一键建议显示在时间页面。您的记录通过以下方式回流到任意日历：",
  "Ready": "就绪",
  "Recently completed": "最近完成",
  "Regenerate": "重新生成",
  "Regenerate link": "重新生成链接",
  "Regenerate recovery codes": "重新生成恢复码",
  "Regenerate the secret link (old link stops working)": "重新生成秘密链接（旧链接失效）",
  "Remove": "移除",
  "Remove item": "移除项",
  "Remove this calendar": "移除此日历",
  "Remove this checklist item": "移除此清单项",
  "Remove this comment; its replies stay": "移除这条评论；它的回复会保留",
  "Repeats": "重复",
  "Reply": "回复",
  "Reply in this thread": "在此话题中回复",
  "Report name": "报表名称",
  "Reports": "报表",
  "Request": "申请",
  "Request failed": "请求失败",
  "Request leave": "申请假期",
  "Reset your password": "重置您的密码",
  "Result": "结果",
  "Resume": "继续",
  "Resume (pauses the running timer)": "继续（暂停正在运行的计时器）",
  "Resume this timer (pauses the running one)": "继续此计时器（暂停正在运行的那个）",
  "Retake baseline": "重新记录基线",
  "Retention": "保留策略",
  "Return the week with a note; the person edits and resubmits": "附备注退回该周；本人编辑后重新提交",
  "Revoke the token \"{name}\"? Anything using it stops working immediately.": "撤销令牌「{name}」？使用它的一切都会立即停止工作。",
  "Role": "角色",
  "Run this report automatically on the chosen cadence and deliver it by email/notification": "按所选频率自动运行此报表并通过邮件/通知送达",
  "Save": "保存",
  "Save every change on this record": "保存此记录上的所有更改",
  "Save policy": "保存策略",
  "Save policy stores the numbers for the nightly run. Run now purges immediately with the saved policy.": "“保存策略”存储数值供夜间运行使用。“立即运行”按已保存策略立即清除。",
  "Save the current grouping and filters under a name": "以名称保存当前分组和筛选",
  "Save these recovery codes now.": "请立即保存这些恢复码。",
  "Saved reports…": "已保存的报表…",
  "Saved ✓": "已保存 ✓",
  "Saved.": "已保存。",
  "Schedule": "计划",
  "Schedule end": "计划结束",
  "Schedule settings per project": "各项目的排程设置",
  "Scheduled reports": "计划报表",
  "Scroll the timeline back to today": "将时间线滚回今天",
  "Search": "搜索",
  "Search code or name…": "搜索代码或名称…",
  "Search…": "搜索…",
  "Send the request to your line manager (some types are approved automatically)": "将申请发送给您的直属经理（部分类型自动批准）",
  "Send them a password reset link from the directory when they are ready to sign in.": "当对方准备登录时，从通讯录发送密码重置链接。",
  "Send them this link — it is shown once and expires in 7 days:": "把此链接发给对方 — 只显示一次，7 天后过期：",
  "Send this project-week to the project administrator for approval; you can withdraw until they decide": "将此项目周发送给项目管理员审批；在其决定前可撤回",
  "Sent back": "已退回",
  "Service account": "服务账户",
  "Set a new password for": "设置新密码：",
  "Set a password": "设置密码",
  "Set status…": "设置状态…",
  "Set the task and a note when you start, or edit them in the list.": "开始时设置任务和备注，或在列表中编辑。",
  "Set up your account": "设置您的账户",
  "Settings": "设置",
  "Share with project": "与项目共享",
  "Show": "显示",
  "Show archived": "显示已归档",
  "Show failed sign-in attempts": "显示失败的登录尝试",
  "Show service accounts": "显示服务账户",
  "Show sign-in attempts": "显示登录尝试",
  "Show subtasks": "显示子任务",
  "Show the audit log": "显示审计日志",
  "Show this project in your lists again": "在您的列表中重新显示此项目",
  "Show this project's tasks": "显示此项目的任务",
  "Show what this comment said before it was edited": "查看这条评论编辑前的内容",
  "Shows their day in the right hours; it never changes which week an entry belongs to.": "按正确的时刻显示其一天；绝不改变记录所属的周。",
  "Sign in": "登录",
  "Sign in with your device's fingerprint, face or PIN, or a hardware key — no password or code needed. Passkeys are phishing-resistant.": "使用设备的指纹、面容或 PIN，或硬件密钥登录 — 无需密码或验证码。通行密钥可抵御钓鱼。",
  "Sign out": "退出登录",
  "Signed in": "已登录",
  "Signing in…": "正在登录…",
  "Since": "自",
  "Sortable table of tasks across every project in the portfolio": "项目组合中所有项目任务的可排序表格",
  "Sortable table of tasks with bulk edit and saved views": "可排序的任务表格，支持批量编辑和保存视图",
  "Start (or switch) your timer for this project onto this task; any running timer pauses": "在此任务上启动（或切换）此项目的计时器；正在运行的计时器将暂停",
  "Start a timer for this project (pauses any running timer)": "为此项目启动计时器（暂停任何正在运行的计时器）",
  "Start timer": "启动计时器",
  "Start timer on this task": "在此任务上启动计时器",
  "Starts": "开始",
  "State": "状态",
  "Status": "状态",
  "Stop and save": "停止并保存",
  "Stop and save one time entry for the total": "停止并按总时长保存一条时间记录",
  "Stop and save one time entry for the total on this project": "停止并按此项目总时长保存一条时间记录",
  "Stop anything using this token, immediately": "立即停止使用此令牌的一切",
  "Stop at idle — save up to the idle moment and stop": "在空闲处停止 — 保存到空闲时刻并停止",
  "Stop reading your Google Calendar": "停止读取您的 Google 日历",
  "Stop the timer running on this task and save one time entry": "停止此任务上运行的计时器并保存一条时间记录",
  "Stop timer": "停止计时器",
  "Store these numbers as the policy; the nightly purge uses them from its next run": "将这些数值存为策略；夜间清除从下次运行起使用",
  "Subscribe": "订阅",
  "Subscribe your calendar app to this link to see your tasks (due dates), leave, your projects' milestones and your last 90 days of time entries.": "在日历应用中订阅此链接，可查看您的任务（到期日）、假期、项目里程碑和最近 90 天的时间记录。",
  "Subscribe your calendar app to your tasks, leave, milestones and recent time entries.": "在日历应用中订阅您的任务、假期、里程碑和最近的时间记录。",
  "Swimlanes": "泳道",
  "System state, the audit trail, and sign-in activity. People and invites are under": "系统状态、审计轨迹和登录活动。人员和邀请位于",
  "Take baseline": "记录基线",
  "Take the project out of this portfolio (the project itself is unchanged)": "将项目移出此项目组合（项目本身不变）",
  "Take the submission back to edit the week; resubmit when ready": "撤回提交以编辑该周；准备好后重新提交",
  "Task": "任务",
  "Task (optional)": "任务（可选）",
  "Task this timer is for (optional)": "此计时器对应的任务（可选）",
  "Task title": "任务标题",
  "Tasks": "任务",
  "Tasks can't move between projects": "任务不能在项目之间移动",
  "Tasks live inside projects; open Projects": "任务位于项目内；请打开项目",
  "Team (last 30 days)": "团队（最近 30 天）",
  "That does not look like a valid zone.": "这看起来不像有效的时区。",
  "The calendar's public iCal URL": "日历的公开 iCal 网址",
  "The link is a secret — anyone holding it can read your feed. Regenerate it if it leaks.": "此链接是秘密 — 任何持有者都能读取您的订阅。若泄露请重新生成。",
  "The numbers below are the": "下面的数字是",
  "The person accountable for the portfolio; always a portfolio administrator": "对项目组合负责的人；始终是项目组合管理员",
  "There is no password yet, so nobody can sign in as them. Issue a password reset link from the directory when they are ready.": "目前还没有密码，因此无人能以其身份登录。等对方准备好后，从通讯录签发密码重置链接。",
  "They can sign in with the password you set.": "对方可以用你设置的密码登录。",
  "This account can only be used from these addresses (set by an administrator):": "此账户只能从这些地址使用（由管理员设置）：",
  "This browser does not support passkeys.": "此浏览器不支持通行密钥。",
  "This invite is invalid or has expired. Ask an administrator for a new one.": "此邀请无效或已过期。请向管理员索取新的邀请。",
  "This password is shown once and will not be shown again. Give it to them over a channel you trust; they can change it under Account.": "此密码只显示一次，不会再次显示。请通过可信渠道交给对方；对方可在账户中修改。",
  "Throw this timer away without saving": "丢弃此计时器且不保存",
  "Time": "时间",
  "Time is approved per project, per week, in each project's own timezone.": "时间按项目、按周审批，以各项目自身时区为准。",
  "Time off is approved by your line manager and reduces your available capacity for that week — it never counts as hours worked.": "假期由您的直属经理审批，并减少您当周的可用工时 — 绝不计为工作时长。",
  "Timeline across projects: cross-project links, critical path": "跨项目时间线：跨项目链接、关键路径",
  "Timeline: drag bars, link dependencies, critical path, baseline": "时间线：拖动条形、连接依赖、关键路径、基线",
  "Timesheets": "工时表",
  "Timezone": "时区",
  "Timezone of truth": "基准时区",
  "Title": "标题",
  "Title of the new task; you can fill in the rest from the task editor": "新任务标题；其余可在任务编辑器中填写",
  "To": "至",
  "To confirm, type your name exactly:": "请准确输入您的姓名以确认：",
  "To connect Claude Code as this account, put the token in the shell and add the server once:": "要以此账户连接 Claude Code，请把令牌放进 shell 并添加一次服务器：",
  "To do": "待办",
  "Token name, e.g. Claude Code": "令牌名称，例如 Claude Code",
  "Top": "顶部",
  "Total": "合计",
  "Turn off": "关闭",
  "Turn off authenticator": "关闭身份验证器",
  "Turn on": "开启",
  "Type": "类型",
  "Type @ to mention someone · Ctrl-Enter posts": "输入 @ 提及某人 · Ctrl-Enter 发布",
  "Type a command, project, task key, or name…  (Ctrl-K toggles)": "输入命令、项目、任务编号或名称…（Ctrl-K 切换）",
  "Type your display name exactly to enable the final button": "准确输入您的显示名以启用最后的按钮",
  "Unarchive": "取消归档",
  "Unassigned": "未分配",
  "Unlock an approved week for edits; requires a reason, recorded in the audit log, and notifies the person": "解锁已批准的周以便编辑；需要理由，记入审计日志，并通知本人",
  "Unshare": "取消共享",
  "Upcoming milestones": "即将到来的里程碑",
  "Update password": "更新密码",
  "Upload": "上传",
  "Use them to try a change with a few people first, or to switch a feature off quickly if it misbehaves.": "用它们先让少数人试用某项更改，或在功能出问题时快速关闭。",
  "Velocity": "速率",
  "Velocity (estimate hours done per week)": "速率（每周完成的估算小时）",
  "Velocity per week": "每周速率",
  "Verify": "验证",
  "Views…": "视图…",
  "WIP limit": "WIP 上限",
  "Week": "周",
  "Week of": "周起始",
  "Weeks awaiting submission": "等待提交的周",
  "Weeks from": "起始周",
  "Weeks run Monday→Monday in": "周为周一→周一，基于",
  "What": "内容",
  "What did you work on?": "您做了什么？",
  "What they see the app in until they choose otherwise.": "在对方另行选择之前，应用会以此语言显示。",
  "What this person costs per hour (effective-dated); click to view history or change it": "此人每小时的成本（按生效日期）；点击查看历史或修改",
  "When": "时间",
  "When done, the next occurrence is created with dates shifted.": "完成后将创建日期顺延的下一次。",
  "Where password resets go. Change it and they are emailed about it.": "密码重置会发送到这里。更改后会邮件通知本人。",
  "Which project the new timer is for": "新计时器所属项目",
  "Who": "人员",
  "Working days per week": "每周工作天数",
  "Write a comment…": "写一条评论…",
  "Write a reply…": "写一条回复…",
  "You are not a member of any project yet, so there is nowhere to log time. Ask a project administrator to add you.": "您还不是任何项目的成员，因此无处记录时间。请让项目管理员添加您。",
  "You become its portfolio manager; add projects and members from the portfolio page, or file a project from its": "您将成为其项目组合经理；可在项目组合页面添加项目和成员，或在项目的以下位置将其归入：",
  "You can also send them the link directly:": "您也可以直接把链接发给对方：",
  "You can see this project's tasks here but not change them": "您可以在此查看此项目的任务，但不能更改",
  "You do not have access to this page.": "您无权访问此页面。",
  "You have been invited as": "您被邀请为",
  "You have no line manager set, so requests will wait for an administrator. Ask an admin to set your manager under People.": "您尚未设置直属经理，因此申请将等待管理员处理。请管理员在人员页面设置您的经理。",
  "You need edit rights in both projects to link them": "需要两个项目的编辑权限才能建立链接",
  "You sign in with Google, which handles two-factor authentication for you. These options apply to password sign-in.": "您使用 Google 登录，Google 已为您处理双因素认证。这些选项适用于密码登录。",
  "You sign in with Google. A password gives you a fallback if Google is unavailable.": "您使用 Google 登录。设置密码可在 Google 不可用时作为备用。",
  "Your colleagues.": "您的同事。",
  "Your feed (out)": "您的订阅（导出）",
  "Your name": "您的姓名",
  "Your own zone, for display. Projects keep their own timezone-of-truth.": "您自己的时区，仅用于显示。项目保留各自的基准时区。",
  "Your role": "您的角色",
  "Your role requires a second factor for password sign-in. Set up an": "您的角色要求密码登录使用第二因素。请设置",
  "Your week is shown in": "您的周显示基于",
  "Zoom": "缩放",
  "active people": "活跃人员",
  "active projects": "活跃项目",
  "approvals arrive in Phase 3": "审批将在第 3 阶段推出",
  "archived": "已归档",
  "assignee: clear": "负责人：清除",
  "assignee: keep": "负责人：保留",
  "audit trail for this project": "此项目的审计轨迹",
  "billable hours": "计费小时",
  "billed amount": "计费金额",
  "by": "按",
  "change in Settings": "在设置中更改",
  "closes Monday": "周一截止",
  "comments and @mentions about the project as a whole": "关于整个项目的评论与 @提及",
  "correction": "更正",
  "cost": "成本",
  "cost / hour": "成本 / 小时",
  "created": "已创建",
  "created → done": "创建 → 完成",
  "critical tasks": "关键任务",
  "current": "当前",
  "current + new + confirm": "当前 + 新密码 + 确认",
  "current 6-digit code": "当前 6 位验证码",
  "days": "天",
  "deleted": "已删除",
  "description, dashboard": "描述、仪表盘",
  "devices signed in as you": "以您身份登录的设备",
  "done": "完成",
  "download everything stored about you": "下载关于您的所有存储数据",
  "due +days": "到期 +天",
  "edited": "已编辑",
  "edited by": "编辑者",
  "est. h": "估算 h",
  "estimate hours": "估算小时",
  "every 2 weeks": "每 2 周",
  "every day": "每天",
  "every month": "每月",
  "every quarter": "每季度",
  "every week": "每周",
  "extra recipients (comma-separated)": "额外收件人（逗号分隔）",
  "failed sign-ins (24h)": "失败的登录（24 小时）",
  "feed URL, Google Calendar, external calendars": "订阅网址、Google 日历、外部日历",
  "fingerprint, face, security key": "指纹、面容、安全密钥",
  "from": "从",
  "generate one and show it to me once": "生成一个并只显示一次",
  "hidden": "已隐藏",
  "hours": "小时",
  "hours and money caps, alerts": "工时与金额上限、提醒",
  "hours logged": "已记录小时",
  "hours logged (yours where restricted)": "已记录小时（受限时仅您的）",
  "iCal subscription link": "iCal 订阅链接",
  "in": "所属：",
  "in progress": "进行中",
  "kept": "保留",
  "last 30 days": "最近 30 天",
  "last month": "上月",
  "last week": "上周",
  "latest scheduled finish across projects": "各项目中最晚的计划完成日期",
  "list view, editor, checklists": "列表视图、编辑器、清单",
  "live sessions": "活跃会话",
  "logged this week": "本周已记录",
  "median cycle time (days)": "周期时间中位数（天）",
  "median lead time (days)": "前置时间中位数（天）",
  "migrations": "迁移",
  "month to date": "本月至今",
  "name, dates, timezone, archive": "名称、日期、时区、归档",
  "name, description, portfolio manager, archive": "名称、描述、项目组合经理、归档",
  "name, language, timezone": "名称、语言、时区",
  "navigate · Enter run · Esc close": "导航 · Enter 执行 · Esc 关闭",
  "never": "从不",
  "no estimates yet": "尚无估算",
  "no rate — billable time counts as unrated": "无费率 — 计费时间按未定价计",
  "no scheduled tasks yet": "尚无已排程任务",
  "non-billable": "非计费",
  "none yet": "尚无",
  "none — portfolio views assign a palette colour": "无 — 项目组合视图会分配调色板颜色",
  "none — they cannot sign in yet": "无 — 对方暂时无法登录",
  "now has an account.": "现在有账户了。",
  "off": "关闭",
  "office, home…": "办公室、家…",
  "on": "开启",
  "open tasks assigned to me": "分配给我的未完成任务",
  "or set a password": "或设置密码",
  "or use a password": "或使用密码",
  "overdue": "已逾期",
  "overdue ·": "已逾期 ·",
  "payroll-ready": "可发工资",
  "people are": "人",
  "permanent — read first": "人",
  "person is": "永久 — 请先阅读",
  "person's zone": "本人时区",
  "policy": "策略",
  "portfolio": "项目组合",
  "portfolio administrator": "项目组合管理员",
  "portfolio end": "项目组合结束",
  "predecessor": "前置任务",
  "priority: keep": "优先级：保留",
  "private": "私有",
  "project administrator": "项目管理员",
  "project zone": "项目时区",
  "projected finish": "预计完成",
  "projects": "项目",
  "rate / hour": "费率 / 小时",
  "read this once": "读一次即可",
  "read-only": "只读",
  "rejected — resubmit": "已拒绝 — 请重新提交",
  "service account": "服务账户",
  "set one now": "现在设置一个",
  "subtask": "子任务",
  "synced": "已同步",
  "system": "系统",
  "taken": "记录于",
  "task count": "任务数",
  "tasks": "任务",
  "tasks done": "已完成任务",
  "then": "然后",
  "this device": "此设备",
  "this week": "本周",
  "throughput": "吞吐量",
  "time entries": "时间记录",
  "time-based codes (TOTP)": "基于时间的验证码（TOTP）",
  "to": "至",
  "to do": "待办",
  "two-way sync": "双向同步",
  "unassigned": "未分配",
  "updated": "已更新",
  "velocity (h / week)": "速率（小时 / 周）",
  "week start": "周起始日",
  "weeks awaiting submission": "等待提交的周",
  "workflow columns and transitions": "工作流列与流转",
  "your hours logged": "您已记录的小时",
  "your password": "您的密码",
  "zero slack: a delay moves the end date": "零浮动：任何延迟都会推迟结束日期",
  "{n} people notified": "已通知 {n} 人",
  "{n} private projects are hidden from these totals.": "{n} 个私有项目未计入这些合计。",
  "{n} private projects hidden": "{n} 个私有项目已隐藏",
  "{n} projects": "{n} 个项目",
  "— (top level)": "—（顶级）",
  "— no task —": "— 无任务 —",
  "— none —": "— 无 —",
  "— unassigned —": "— 未分配 —",
  "🔒 approved": "🔒 已批准",
  "Task completed.": "任务已完成。",
  "Task reopened.": "任务已重新打开。",
  "Applies immediately to this browser and every device you sign in on; overrides the browser language.": "立即应用于此浏览器及您登录的所有设备；覆盖浏览器语言。",
  "A confirmation link was sent to the new address (valid 2 days). Your email changes when you open it.": "确认链接已发送到新地址（2 天内有效）。打开后邮箱即更改。",
  "Cancel it": "取消",
  "Change email": "更改邮箱",
  "Change now": "立即更改",
  "Change now (with password)": "立即更改（需密码）",
  "Change the email immediately": "立即更改邮箱",
  "Changed. Use the new address next time you sign in.": "已更改。下次登录请使用新地址。",
  "Confirm email": "确认邮箱",
  "Done — your sign-in email is now": "完成 — 您的登录邮箱现在是",
  "Either way the old address is told, and the change is recorded in the audit log.": "无论哪种方式，旧地址都会收到通知，且更改会记入审计日志。",
  "Mail is not configured on this server, so open this link yourself (valid 2 days):": "此服务器未配置邮件，请自行打开此链接（2 天内有效）：",
  "New email": "新邮箱",
  "Send a confirmation link to the new address": "向新地址发送确认链接",
  "Send confirmation link": "发送确认链接",
  "This account signs in with Google, so its email is managed by Google and cannot be changed here.": "此账户使用 Google 登录，邮箱由 Google 管理，无法在此更改。",
  "Verify first": "先验证",
  "Verify first (send a link)": "先验证（发送链接）",
  "Waiting for confirmation of": "等待确认：",
  "Your email is what you sign in with and where notifications are mailed.": "邮箱用于登录并接收通知邮件。",
  "a link is sent to the new address; the change happens when you open it, so a typo can't lock you out.": "链接会发送到新地址；打开后才会更改，因此拼写错误不会把您锁在外面。",
  "enter your current password and the address changes immediately.": "输入当前密码，地址会立即更改。",
  "expires": "过期",
  "A status update is waiting to be sent to GitHub": "状态更新正在等待发送到 GitHub",
  "API calls left this hour": "本小时剩余 API 调用",
  "Assign to matching people": "分配给匹配的人员",
  "Close and reopen issues when task status changes": "任务状态变化时关闭和重新打开 issue",
  "Connect": "连接",
  "Connect a repository to import its issues as tasks. When a task is finished here, the issue is closed on GitHub; when an issue is closed or reopened on GitHub, the task follows.": "连接仓库以将其 issue 导入为任务。在此完成任务时，GitHub 上的 issue 会被关闭；在 GitHub 上关闭或重新打开 issue 时，任务会随之变化。",
  "Connected to": "已连接到",
  "Could not load the GitHub connection.": "无法加载 GitHub 连接。",
  "Create missing milestones": "创建缺失的里程碑",
  "Disconnect": "断开连接",
  "Disconnect this repository? Existing issue links are kept; nothing is deleted on GitHub.": "断开此仓库？现有的 issue 链接会保留；GitHub 上不会删除任何内容。",
  "Fine-grained personal access token": "细粒度个人访问令牌",
  "GITHUB_WEBHOOK_SECRET is not set on the server, so changes made on GitHub reach APM by hourly polling or “Sync now” rather than instantly.": "服务器未设置 GITHUB_WEBHOOK_SECRET，因此 GitHub 上的更改通过每小时轮询或“立即同步”到达 APM，而非即时。",
  "GitHub": "GitHub",
  "GitHub username": "GitHub 用户名",
  "GitHub → Settings → Developer settings → Fine-grained tokens. Limit it to this repository with permission Issues: Read and write (Metadata is included automatically). The token is verified now, stored encrypted, and never shown again.": "GitHub → Settings → Developer settings → Fine-grained tokens。仅限此仓库，授予 Issues: Read and write 权限（Metadata 会自动包含）。令牌现在会被验证、加密存储，且不再显示。",
  "Import issues": "导入 issue",
  "Import issues…": "导入 issue…",
  "Importing…": "正在导入…",
  "Issue closed as completed →": "以“已完成”关闭的 issue →",
  "Issue closed as not planned →": "以“不计划”关闭的 issue →",
  "Issue reopened →": "重新打开的 issue →",
  "Issues assigned to this GitHub user become tasks assigned to you when a project imports them.": "分配给此 GitHub 用户的 issue 在项目导入时会成为分配给你的任务。",
  "Labels": "标签",
  "Mirror the task status as an apm:… label": "将任务状态镜像为 apm:… 标签",
  "Moving a task into this status closes the issue as “not planned”; any other done status closes it as “completed”.": "将任务移入此状态会以“不计划”关闭 issue；其他任何完成状态会以“已完成”关闭。",
  "No APM account has this GitHub username": "没有 APM 账户使用此 GitHub 用户名",
  "No issues match.": "没有匹配的 issue。",
  "Priority from labels": "根据标签设置优先级",
  "Replace the token or test the connection to resume.": "替换令牌或测试连接以恢复。",
  "Replace token": "替换令牌",
  "Repository": "仓库",
  "Status mapping": "状态映射",
  "Sync history": "同步历史",
  "Sync is paused:": "同步已暂停：",
  "Sync now": "立即同步",
  "Synced:": "已同步：",
  "Syncing…": "正在同步…",
  "Test connection": "测试连接",
  "Webhook: add": "Webhook：添加",
  "When an imported issue carries one of these labels, the task gets the matching priority (first match wins).": "导入的 issue 带有这些标签之一时，任务将获得相应优先级（首个匹配生效）。",
  "all": "全部",
  "already linked": "已链接",
  "attempt": "尝试",
  "checked": "已检查",
  "closed": "已关闭",
  "create": "创建",
  "errors": "错误",
  "failed": "失败",
  "first done status": "第一个完成状态",
  "first to-do status": "第一个待办状态",
  "import issues as tasks, sync status": "导入 issue 为任务，同步状态",
  "label, e.g. bug": "标签，例如 bug",
  "labels, comma-separated": "标签，逗号分隔",
  "last checked": "上次检查",
  "linked issues": "已链接的 issue",
  "next": "下一页",
  "not planned": "不计划",
  "nothing to do": "无需操作",
  "open": "打开",
  "open issues": "打开的 issue",
  "page": "页",
  "previous": "上一页",
  "remove": "移除",
  "running": "运行中",
  "same as completed": "与已完成相同",
  "search title or #number": "搜索标题或 #编号",
  "sent to GitHub": "已发送到 GitHub",
  "to the repository with the server's GITHUB_WEBHOOK_SECRET, content type JSON, events: Issues, Pushes, Pull requests. Without it, changes still arrive by hourly polling or “Sync now”.": "到仓库，使用服务器的 GITHUB_WEBHOOK_SECRET，内容类型 JSON，事件：Issues、Pushes、Pull requests。没有它，更改仍会通过每小时轮询或“立即同步”到达。",
  "token": "令牌",
  "update": "更新",
  "update pending": "更新待处理",
  "updated here": "在此更新",
  "updates waiting": "更新等待中",
  "Open menu": "打开菜单",
  "Close menu": "关闭菜单",
  "Main menu": "主菜单",
  "Management": "管理",
}
